import BackgroundVideo from "components/BackgroundVideo";
import ChatBox from "components/ChatBox";
import Header from "components/Header";
import ModalConfirmLogout from "components/ModalConfirmLogout";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function RecipeHome() {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const navigate = useNavigate();
  return (
    <section
      className="min-h-screen md:px-14 px-4 md:py-10 bg-fixed bg-cover mb-0 md:mb-96"
      //   style={{
      //     backgroundImage: `url('/assets/bg-new.png')`,
      //   }}
    >
      <BackgroundVideo />

      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className=" py-12" />
      <div className="flex flex-col justify-center items-center ">
        {/* pc btn back */}
        <div
          className="flex w-full justify-end items-center cursor-pointer md:mb-2 mb-6 md:mt-0 mt-2 btn-hover"
          onClick={() => {
            navigate("/");
          }}
        >
          <img
            className="md:w-[239px] md:h-[69px] w-1/3 "
            src="/assets/btn-back.png"
            alt="Quay lại"
          />
        </div>

        {/* Title */}
        <div className="flex flex-col justify-center items-center md:mt-0 mt-12">
          <img
            src="/assets/header-logo.png"
            alt="TOOL BACCARAT AI 2026"
            className="mb-4"
            onClick={() => {
              navigate("/");
            }}
          />
          <img
            className="mb-6"
            src="/assets/bcr-f1.png"
            alt="CÔNG NGHỆ TOOL UPDATE MỚI NHẤT TRÊN THỊ TRƯỜNG"
          />
          <img
            className="mb-2"
            src="/assets/home-title.png"
            alt="CHÀO MỪNG ĐẾN VỚI TOOL BACCARAT V6E"
          />
        </div>
      </div>
      <div className="grid md:grid-cols-2 place-items-center gap-6 w-full mt-4 md:py-0 pb-12">
        <img
          src="/assets/recipe-robot.png"
          alt="robot"
          className="md:w-1/3 w-[80%]  shadow-md shadow-yellow-200 btn-hover cursor-pointer"
          onClick={() => {
            navigate("/casino");
          }}
        />

        <img
          src="/assets/recipe-basicToVip.png"
          alt="card"
          className="md:w-1/3 w-[80%]   shadow-md shadow-yellow-200 btn-hover cursor-pointer"
          onClick={() => {
            navigate("/cong-thuc-baccarat");
          }}
        />
      </div>
      {/* Chatbox */}
      <ChatBox />
      {/* Modal Logout */}
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </section>
  );
}

export default RecipeHome;
